import { Grid, Link, ListItem } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import HorizontalList from 'src/components/elements/HorizontalList';
import Section from 'src/components/elements/Section';
import { ROUTE_CONTACT, ROUTE_COOKIES, ROUTE_IMPRINT, ROUTE_PRIVACYPOLICY } from 'src/config/routes';

const FooterLink = styled(Link)({
    color: 'inherit',
}) as typeof Link;

const FOOTER_LINKS = [
    { key: 'footer.cookies', route: ROUTE_COOKIES },
    { key: 'footer.imprint', route: ROUTE_IMPRINT },
    { key: 'footer.privacy', route: ROUTE_PRIVACYPOLICY },
    { key: 'footer.kontakt', route: ROUTE_CONTACT },
];

const CoffeehouseFooter: React.FC = () => {
    const { t } = useTranslation('coffeehouse');
    return (
        <footer>
            <Section component="div" sx={{ bgcolor: 'grey.800', color: 'common.white' }} spacing="compact">
                <Grid container justifyContent="flex-end">
                    <Grid item>
                        <HorizontalList dense>
                            {FOOTER_LINKS.map(({ key, route }) => (
                                <ListItem key={route.path}>
                                    <FooterLink {...(route.componentProps as any)} style={{ color: 'white' }}>
                                        {t(key)}
                                    </FooterLink>
                                </ListItem>
                            ))}
                        </HorizontalList>
                    </Grid>
                </Grid>
            </Section>
        </footer>
    );
};

export default CoffeehouseFooter;
